import axios from '../../axios'

export default {
  getTunnels (light) {
    return axios.get('/tunnels' + (light ? '?light=true' : ''))
  },
  getTunnel (tunnelId) {
    return axios.get(`/tunnels/${tunnelId}`)
  },
  getTunnelSetupScript (tunnelId) {
    return axios.get(`/tunnels/${tunnelId}/setupScript`)
  },
  addTunnel (tunnel) {
    return axios.post('/tunnels', {
      name: tunnel.name,
      endpoint_peer: tunnel.endpoint,
      location: tunnel.location,
      bind_port: tunnel.port,
    })
  },
  updateTunnel (tunnel, tunnelId) {
    return axios.put(`/tunnels/${tunnelId}`, {
      name: tunnel.name,
      endpoint_public_key: tunnel.endpoint_public_key,
      endpoint_peer: tunnel.endpoint,
      location: tunnel.location,
      bind_port: tunnel.port,
    })
  },
  deleteTunnel (tunnelId) {
    return axios.delete(`/tunnels/${tunnelId}`)
  },
  getTunnelBindPort () {
    return axios.get('/tunnels/getBindPort')
  },
  getTunnelLocations () {
    return axios.get('/tunnels/locations')
  },
  getTunnelAnalytics (tunnelId, type, period, points) {
    return axios.get(`/tunnels/${tunnelId}/analytics?type=${type}&period=${period}&points=${points}`)
  },
  getTunnelFilters () {
    return axios.get(`/tunnelFilters`)
  },
  addTunnelFirewall (tunnelId, firewall) {
    return axios.post(`/tunnel/${tunnelId}/tunnelFirewall`, {
      start_port: firewall.startPort,
      end_port: firewall.endPort,
      filter_id: firewall.filterId,
      is_active: firewall.isActive,
    })
  },
  getTunnelFirewalls (tunnelId) {
    return axios.get(`/tunnel/${tunnelId}/tunnelFirewalls`)
  },
  deleteTunnelFirewall (filterId) {
    return axios.delete(`/tunnelFirewall/${filterId}`)
  },
  updateTunnelFirewall (firewall, filterId) {
    return axios.put(`/tunnelFirewall/${filterId}`, {
      start_port: firewall.startPort,
      end_port: firewall.endPort,
      filter_id: firewall.filterId,
      is_active: firewall.isActive,
    })
  },
  getTunnelFirewall (filterId) {
    return axios.get(`/tunnelFirewall/${filterId}`)
  },
}
